import type { IconData } from '@stacksjs/iconify-core'

export const otherUiGraph: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15.965 8.75A8 8 0 1 1 7.25.035V8.75z\"/><path fill=\"currentColor\" d=\"M8.75.035V7.25h7.215A8 8 0 0 0 8.75.035\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiGraph
